import React from 'react'

import { TriggerTypes } from '../stores/AlertStore'

function TriggerSelect(defaultValue, onChange) {
	return (
		<select defaultValue={defaultValue} onChange={onChange}>
			{
				TriggerTypes.map(arr => {
					let [val, name] = arr
					return <option key={val} value={val}>{name}</option>
				})
			}
  	</select>
	)
}

export default class AlertEditor extends React.Component {
	state = {
		alert: null
	}

	componentDidMount() {
		let {alert} = this.props
		this.setState({alert})
	}

	changePrice = (e) => {
		let {alert} = this.state
		alert.target = e.target.value // THIS IS A STRING
		this.setState({alert})
	}

	changeTrigger = (e) => {
		let {alert} = this.state
		alert.trigger = e.target.value
		this.setState({alert})
	}

	save = () => {
		let canSave = true
		let {alert} = this.state
		if (alert.trigger.indexOf('prct') !== -1) {
			// check for valid percentage, must be greater than 1
			if (Number(alert.target) < 1) {
				canSave = false
				window.alert('Please enter a valid percentage for target, such as 5 or 10.')
			}
		}

		if (canSave) this.props.onSave()
	}

	prettify(symbol) {
    const [a, b] = symbol.split('_')
    return b + a
  }

	render() {
		let {alert} = this.state
		let {canDelete} = this.props

		if (!alert) return (<div></div>)

		return (
			<div className='absolute alert-editor z-index-100 shadow-2'>
        <div className='w-10'>
          <button className='bg-animate' onClick={this.props.onCancel}>Cancel</button>
        </div>
        <div className='w-100 pa2'>
        	Symbol: 
          <input defaultValue={this.prettify(alert.symbol)} readOnly
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
        </div>
        <div className='w-100 pa2'>
        	Target: 
          <input value={alert.target} onChange={this.changePrice}
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
          <small>Enter price or %.</small>
        </div>
        <div className='w-100 pa2'>
        	<span className='di pr1'>Trigger:</span>
        	{ TriggerSelect(alert.trigger, this.changeTrigger) }
        </div>
        <div className='w-100 pa2'>
        	<button className='bg-animate' onClick={this.save}>Save</button>
        	{ canDelete &&
	        	<button className='bg-animate fr' onClick={this.props.onDelete}>Delete</button>}
        </div>
      </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/AlertEditor.js